import {Component, OnInit} from '@angular/core';
import {DashNumbers} from "../objects/main";
import {HomeService} from "../../public/home/home.service";

@Component({
	selector: 'app-our-numbers',
	templateUrl: './our-numbers.component.html',
	styleUrls: ['./our-numbers.component.scss']
})
export class OurNumbersComponent implements OnInit {
	public dashNumbers: DashNumbers;

	constructor(private homeService: HomeService) {
	}

	ngOnInit(): void {
		this.homeService.getDashboardNumbers().then(
			(response) => this.dashNumbers = response
		);
	}

}
